var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/colors.ts
var colors = {
  gray00: "#ffffff",
  gray10: "#fafafa",
  gray20: "#f3f3f3",
  gray30: "#e3e3e3",
  gray40: "#cccccc",
  gray50: "#8d8d8d",
  gray60: "#6d6d6d",
  gray70: "#4b4b4b",
  gray80: "#2b2b2b",
  gray90: "#0f0f0f",
  orange10: "#fff8f1",
  orange20: "#fdcca0",
  orange40: "#f8ac67",
  orange60: "#fa8005",
  orange70: "#ea5200",
  orange80: "#ae440a",
  blue10: "#e8f4fa",
  blue20: "#c1f0fc",
  blue40: "#67dfff",
  blue60: "#3ab3d5",
  blue70: "#1d67b6",
  blue80: "#0c3a6b",
  green10: "#f9fed0",
  green20: "#e8f57b",
  green40: "#bacb2a",
  green60: "#8bbd26",
  green70: "#44a112",
  green80: "#215107",
  red10: "#fff8f8",
  red20: "#fec8c9",
  red40: "#f38a8a",
  red60: "#dd4142",
  red70: "#8b0027",
  red80: "#4d0419",
  yellow10: "#fffdf1",
  yellow30: "#fdf4a0",
  yellow40: "#f8ea67",
  yellow60: "#fae205",
  yellow70: "#eac500",
  yellow80: "#ae8a0a"
};

// src/components/index.ts
var components_exports = {};
__export(components_exports, {
  Badge: () => Badge,
  Button: () => Button,
  Card: () => Card,
  Checkbox: () => Checkbox,
  CheckboxGroup: () => CheckboxGroup,
  Dialog: () => Dialog,
  Divider: () => Divider,
  Headline: () => Headline,
  HelpText: () => HelpText,
  Image: () => Image,
  Input: () => Input,
  Label: () => Label,
  Link: () => Link,
  List: () => List,
  ListBox: () => ListBox,
  Menu: () => Menu,
  Message: () => Message,
  NumberField: () => NumberField,
  Radio: () => Radio,
  Select: () => Select,
  Slider: () => Slider,
  Switch: () => Switch,
  Table: () => Table,
  Text: () => Text,
  TextArea: () => TextArea,
  Tooltip: () => Tooltip,
  Underlay: () => Underlay
});

// src/components/Badge.style.ts
var Badge = {
  base: {
    display: "inline-flex",
    alignItems: "center",
    fontSize: "xxsmall",
    borderRadius: "large",
    border: "2px solid transparent",
    whiteSpace: "nowrap",
    py: 4,
    px: 12
  },
  variant: {
    info: {
      color: "blue10",
      borderColor: "blue80",
      bg: "blue70"
    }
  }
};

// src/components/Button.style.ts
var Button = {
  base: {
    border: "none",
    borderRadius: "small",
    lineHeight: "48px",
    px: "large",
    outline: "none",
    "&[data-focus-visible]": {
      outline: "1px solid",
      outlineColor: "primary",
      outlineOffset: "1px"
    },
    "&:disabled": {
      color: "gray40",
      bg: "gray20"
    }
  },
  variant: {
    primary: {
      color: "background",
      bg: "primary",
      "&:hover": {
        color: "background",
        bg: "orange40"
      }
    },
    secondary: {
      color: "background",
      bg: "secondary",
      "&:hover": {
        color: "background",
        bg: "gray60"
      }
    },
    ghost: {
      color: "secondary",
      border: "1px solid",
      outlineColor: "gray70",
      "&:hover": {
        color: "secondary",
        bg: "gray40"
      }
    },
    text: {
      color: "secondary",
      "&:hover": {
        color: "secondary",
        outlineColor: "gray70",
        bg: "gray40"
      }
    },
    menu: {
      color: "secondary",
      bg: "background",
      "&:hover": {
        color: "background",
        bg: "gray60"
      }
    }
  },
  size: {
    small: {
      lineHeight: "32px",
      px: "small"
    }
  }
};

// src/components/Card.style.ts
var Card = {
  base: {
    bg: "gray00",
    p: "small",
    boxShadow: "0px 4px 4px rgba(165, 165, 165, 0.25)",
    borderRadius: "large"
  }
};

// src/components/Checkbox.style.ts
var Checkbox = {
  base: {
    label: {
      fontSize: "xsmall",
      "&:disabled": {
        color: "gray40"
      }
    },
    checkbox: {
      borderRadius: "small",
      borderColor: "gray40",
      "&:hover": {
        borderColor: "gray50"
      },
      "&:focus": {
        outline: "2px solid",
        outlineColor: "orange60",
        outlineOffset: 3
      },
      "&:checked": {
        color: "white",
        borderColor: "orange80",
        bg: "primary"
      },
      "&:indeterminate": {
        color: "white",
        borderColor: "orange80",
        bg: "primary"
      },
      "&:disabled": {
        bg: "gray30",
        borderColor: "gray40"
      }
    }
  }
};

// src/components/CheckboxGroup.style.ts
var CheckboxGroup = {
  base: {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "xxsmall"
    }
  }
};

// src/components/Dialog.style.ts
var Dialog = {
  base: {
    container: {
      fontFamily: "body",
      borderRadius: "2px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      pl: "large",
      pr: "large",
      pb: "large",
      pt: "small"
    },
    closeButton: {
      position: "relative",
      right: "-24px",
      top: "-8px"
    }
  }
};

// src/components/Divider.style.ts
var Divider = {
  base: {
    width: "100%",
    height: "1px",
    bg: "text"
  },
  variant: {
    bold: {
      height: "2px"
    },
    section: {
      bg: "gray50"
    }
  }
};

// src/components/Headline.style.ts
var Headline = {
  base: {
    fontWeight: "heading"
  },
  size: {
    "level-1": {
      fontSize: "xlarge"
    },
    "level-2": {
      fontSize: "large"
    },
    "level-3": {
      fontSize: "medium"
    },
    "level-4": {
      fontSize: "small"
    },
    "level-5": {
      fontSize: "xsmall"
    },
    "level-6": {
      fontSize: "xsmall",
      textTransform: "uppercase"
    }
  }
};

// src/components/HelpText.style.ts
var HelpText = {
  base: {
    container: {
      fontSize: "xxsmall",
      color: "text",
      "&:error": {
        color: "error"
      }
    },
    icon: {
      size: "xxsmall"
    }
  }
};

// src/components/Image.style.ts
var Image = {
  base: {}
};

// src/components/Input.style.ts
var Input = {
  base: {
    color: "text",
    lineHeight: "large",
    bg: "gray00",
    border: "1px solid",
    borderColor: "gray40",
    borderRadius: "small",
    outline: "none",
    py: "none",
    px: "xsmall",
    "&:hover": {
      borderColor: "gray50"
    },
    "&:focus": {
      borderColor: "orange60",
      boxShadow: `0 0 0 1px ${colors.orange60}`
    },
    "&:disabled": {
      bg: "gray20",
      color: "gray40",
      cursor: "not-allowed"
    },
    "&:error": {
      borderColor: "red60",
      boxShadow: `0 0 0 1px ${colors.red60}`
    },
    "&:in-group": {
      border: "none",
      boxShadow: "none"
    }
  }
};

// src/components/Label.style.ts
var Label = {
  base: {
    fontSize: "xxsmall",
    color: "text",
    "&:disabled": {
      color: "gray40"
    }
  }
};

// src/components/Link.style.ts
var Link = {
  base: {
    color: "blue60",
    "&:hover": {
      textDecoration: "none"
    },
    "&:disabled": {
      cursor: "disabled"
    }
  },
  variant: {
    menuItemLink: {
      color: "text",
      textDecoration: "none"
    }
  }
};

// src/components/List.style.ts
var List = {
  base: {}
};

// src/components/ListBox.style.ts
var ListBox = {
  base: {
    container: {
      mt: 2,
      bg: "gray00",
      border: "1px solid",
      borderColor: "gray40",
      borderRadius: "small",
      "&:error": {
        borderColor: "error"
      }
    },
    list: {
      outline: "none"
    },
    option: {
      p: "xsmall",
      outline: "none",
      cursor: "pointer",
      "&:focus": {
        bg: "orange20"
      },
      "&:selected": {
        color: "gray00",
        bg: "orange60"
      },
      "&:disabled": {
        cursor: "not-allowed",
        color: "gray40"
      }
    },
    sectionTitle: {
      color: "gray50",
      fontSize: "xxsmall",
      pt: "xsmall",
      px: "xsmall"
    },
    section: {
      outline: "none",
      "&:nth-child(n+1)": {
        borderTop: "1px solid",
        borderColor: "gray40"
      }
    }
  }
};

// src/components/Menu.style.ts
var Menu = {
  base: {
    container: {
      bg: "gray00",
      border: "1px solid",
      borderColor: "gray40",
      borderRadius: "small"
    },
    item: {
      px: "small",
      py: "xxsmall",
      cursor: "pointer",
      "&:focus": {
        bg: "gray20"
      }
    }
  }
};

// src/components/Message.style.ts
var Message = {
  base: {
    container: {
      borderStyle: "solid",
      borderWidth: "2px 2px 2px 16px",
      pt: "xsmall",
      pb: "small",
      px: "small",
      fontSize: "xxsmall",
      color: "gray70",
      bg: "gray10"
    },
    title: {
      lineHeight: "large",
      fontWeight: "bold"
    },
    content: {
      lineHeight: "small"
    },
    icon: {
      display: "flex",
      alignItems: "center",
      size: 16
    }
  },
  variant: {
    warning: {
      container: {
        borderColor: "warning"
      },
      icon: {
        color: "warning"
      }
    },
    error: {
      container: {
        borderColor: "error"
      },
      icon: {
        color: "error"
      }
    },
    info: {
      container: {
        borderColor: "info"
      },
      icon: {
        color: "info"
      }
    }
  }
};

// src/components/NumberField.style.ts
var NumberField = {
  base: {
    group: {
      border: "1px solid",
      borderColor: "gray40",
      borderRadius: "small",
      "&:hover": {
        borderColor: "gray50"
      },
      "&:focus": {
        borderColor: "orange60",
        boxShadow: `0 0 0 1px ${colors.orange60}`
      },
      "&:disabled": {
        bg: "gray20",
        color: "gray40",
        cursor: "not-allowed"
      },
      "&:error": {
        borderColor: "red60",
        boxShadow: `0 0 0 1px ${colors.red60}`
      }
    },
    stepper: {
      color: "text",
      width: "xsmall",
      "&:nth-of-type(1)": {
        borderRight: "1px solid",
        borderColor: "gray40"
      },
      "&:nth-of-type(2)": {
        borderLeft: "1px solid",
        borderColor: "gray40"
      },
      "&:hover": {
        color: "gray90",
        bg: "gray10"
      },
      "&:disabled": {
        color: "gray40"
      },
      "&:hover-group": {
        borderColor: "gray50"
      },
      "&:focus-group": {
        borderColor: "orange60"
      },
      "&:error-group": {
        borderColor: "red60"
      }
    }
  }
};

// src/components/Radio.style.ts
var Radio = {
  base: {
    label: {
      fontSize: "xsmall",
      "&:disabled": {
        color: "gray40"
      }
    },
    radio: {
      borderColor: "gray40",
      "&:hover": {
        borderColor: "gray50"
      },
      "&:focus": {
        outline: "2px solid",
        outlineColor: "orange60",
        outlineOffset: 3
      },
      "&:checked": {
        color: "white",
        borderColor: "orange80",
        bg: "primary"
      },
      "&:disabled": {
        bg: "gray30",
        borderColor: "gray40"
      }
    }
  }
};

// src/components/Select.style.ts
var Select = {
  base: {
    button: {
      appearance: "none",
      lineHeight: "large",
      px: "xsmall",
      bg: "gray00",
      borderRadius: "small",
      border: "1px solid",
      borderColor: "gray40",
      outline: "none",
      cursor: "pointer",
      "&:hover": {
        borderColor: "gray50"
      },
      "&:disabled": {
        color: "gray40",
        bg: "gray20",
        borderColor: "gray40",
        cursor: "not-allowed"
      },
      "&:focus-visible": {
        borderColor: "orange60",
        boxShadow: `0 0 0 1px ${colors.orange60}`
      },
      "&:expanded": {
        bg: "gray20",
        borderColor: "gray40"
      },
      "&:error": {
        borderColor: "error"
      }
    }
  }
};

// src/components/Slider.style.ts
var Slider = {
  base: {
    track: {
      width: "100%",
      position: "absolute",
      top: 16,
      height: 8,
      border: "none",
      borderColor: "transparent",
      borderRadius: "large",
      color: "transparent",
      bg: "gray30"
    },
    thumb: {
      verticalAlign: "middle",
      border: "4px solid",
      borderColor: "gray70",
      width: 16,
      height: 16,
      bg: "gray00",
      borderRadius: "large",
      "&:focus": {
        border: "4px solid",
        borderColor: "orange60"
      },
      "&:disabled": {
        border: "4px solid",
        borderColor: "gray40",
        bg: "gray40"
      }
    },
    label: {
      color: "text",
      fontSize: "xxsmall",
      fontWeight: "body"
    },
    output: {
      color: "text",
      fontSize: "xxsmall",
      fontWeight: "body"
    }
  }
};

// src/components/Switch.style.ts
var Switch = {
  base: {
    track: {
      bg: "gray20",
      boxShadow: `inset 0 0 0 1px ${colors.gray40}`,
      "&:checked": {
        bg: "primary",
        boxShadow: `inset 0 0 0 1px ${colors.orange80}`
      },
      "&:disabled": {
        opacity: 0.5,
        bg: "gray30",
        boxShadow: `inset 0 0 0 1px ${colors.gray40}`
      },
      "&:focus": {
        outline: "2px solid",
        outlineColor: "orange60",
        outlineOffset: 3
      }
    },
    thumb: {
      boxShadow: "1px 1px 4px rgba(0, 0, 0, 0.25)",
      "&:disabled": {
        bg: "gray20"
      }
    }
  },
  size: {
    large: {
      track: {
        width: 96,
        height: 48,
        borderRadius: 40
      },
      thumb: {
        top: 2,
        width: 44,
        height: 44,
        "&:checked": {
          transform: "translateX(calc(95px - 44px))"
        }
      }
    }
  }
};

// src/components/Table.style.ts
var Table = {
  base: {
    table: { borderCollapse: "collapse", fontSize: "xxsmall" },
    header: {
      py: "small",
      px: "small",
      cursor: "default",
      color: "gray70",
      textAlign: "left",
      borderBottom: "1px solid",
      borderColor: "gray50",
      "&:focus": {
        outlineColor: "orange60"
      }
    },
    row: {
      "&:selected": {
        bg: "orange10"
      },
      "&[data-hover]": {
        bg: "gray20"
      },
      "&:focus-visible": {
        outlineColor: "orange60"
      }
    },
    cell: {
      py: "small",
      px: "small",
      color: "gray70",
      borderBottom: "1px solid",
      borderColor: "gray50",
      "&:focus": {
        outlineColor: "orange60"
      }
    }
  },
  variant: {
    compact: {
      header: {
        py: "xsmall"
      },
      cell: {
        py: "xsmall"
      }
    },
    expanded: {
      header: {
        py: "medium"
      },
      cell: {
        py: "medium"
      }
    }
  }
};

// src/components/Text.style.ts
var Text = {
  base: {
    fontSize: "xxsmall"
  }
};

// src/components/TextArea.style.ts
var TextArea = {
  base: {
    color: "text",
    lineHeight: "large",
    border: "1px solid",
    borderColor: "gray40",
    borderRadius: "small",
    outline: "none",
    py: "none",
    px: "xsmall",
    "&:hover": {
      borderColor: "gray50"
    },
    "&:focus": {
      borderColor: "orange60",
      boxShadow: `0 0 0 1px ${colors.orange60}`
    },
    "&:disabled": {
      bg: "gray20",
      color: "gray40",
      cursor: "not-allowed"
    },
    "&:error": {
      borderColor: "red60",
      boxShadow: `0 0 0 1px ${colors.red60}`
    }
  }
};

// src/components/Tooltip.style.ts
var arrowSize = 8;
var Tooltip = {
  base: {
    container: {
      fontSize: "xxsmall",
      lineHeight: "small",
      border: "1px solid",
      borderColor: "blue70",
      borderRadius: "large",
      bg: "blue10",
      p: "xsmall",
      '&[data-placement="top"]': {
        mb: arrowSize
      },
      '&[data-placement="right"]': {
        ml: arrowSize
      },
      '&[data-placement="bottom"]': {
        mt: arrowSize
      },
      '&[data-placement="left"]': {
        mr: arrowSize
      }
    },
    arrow: {
      borderWidth: arrowSize,
      borderTopColor: "blue70",
      "::after": {
        content: '""',
        position: "absolute",
        height: 0,
        width: 0,
        borderStyle: "solid",
        borderLeftColor: "transparent",
        borderRightColor: "transparent",
        borderBottomColor: "transparent",
        borderWidth: arrowSize - 1,
        borderTopColor: "blue10",
        left: `-${arrowSize - 1}px`,
        top: `-${arrowSize}.5px`
      },
      '[data-placement="right"] &, [data-placement="left"] &': {
        top: "50%",
        mt: `-${arrowSize}px`,
        "::after": {
          top: `-${arrowSize}.5px`
        }
      },
      '[data-placement="top"] &, [data-placement="bottom"] &': {
        ml: `-${arrowSize}px`
      },
      '[data-placement="top"] & ': {
        top: "100%"
      },
      '[data-placement="right"] &': {
        right: "100%",
        transform: "rotate(90deg)"
      },
      '[data-placement="bottom"] & ': {
        bottom: "100%",
        transform: "rotate(180deg)"
      },
      '[data-placement="left"] &': {
        left: "100%",
        transform: "rotate(270deg)"
      }
    }
  }
};

// src/components/Underlay.style.ts
var Underlay = {
  base: {
    bg: "rgba(206, 212, 218, 0.5)",
    backdropFilter: "blur(1px)"
  }
};

// src/index.ts
var webFontUrl = [
  "https://fonts.bunny.net/css?family=inter:400,600,700"
];
var theme = {
  breakpoints: ["40em", "52em", "64em"],
  space: {
    none: 0,
    xxsmall: 4,
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 32,
    xlarge: 40,
    xxlarge: 48
  },
  sizes: {
    none: 0,
    xxsmall: 16,
    xsmall: 32,
    small: 40,
    medium: 80,
    large: 120,
    xlarge: 160,
    xxlarge: 240,
    huge: 320,
    epic: 480
  },
  colors: {
    ...colors,
    text: colors.gray70,
    background: colors.gray10,
    primary: colors.orange60,
    secondary: colors.gray70,
    disabled: colors.gray40,
    error: colors.red60,
    warning: colors.yellow70,
    info: colors.blue70,
    success: colors.green70
  },
  root: {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "body",
      bg: "gray00"
    }
  },
  radii: {
    none: 0,
    small: 2,
    medium: 4,
    large: 8
  },
  fonts: {
    body: "Inter",
    heading: "Inter Black"
  },
  fontSizes: {
    xxsmall: "0.875rem",
    xsmall: "1rem",
    small: "1.125rem",
    medium: "1.25rem",
    large: "1.5rem",
    xlarge: "2rem"
  },
  fontWeights: {
    body: 400,
    heading: 900,
    bold: 700
  },
  lineHeights: {
    xsmall: 1,
    small: 1.125,
    medium: 1.5,
    large: 2,
    xlarge: 2.5,
    xxlarge: 3
  },
  components: components_exports
};
var src_default = theme;
export {
  src_default as default,
  webFontUrl
};
